import BaseApi from './BaseApi';
class ShiftPharmacistApi extends BaseApi {
  protected getSpecificApiPrefix(): string {
    return 'managers/pharmacist-shifts';
  }
}

export default ShiftPharmacistApi;
